<template>
  <div
    v-if="durationMonths >= 7 && durationMonths < 10"
    class="alert alert-warning d-flex align-items-center"
    :class="spacingClass"
    data-testid="depreciation-warning"
  >
    <font-awesome-icon :icon="'fas fa-exclamation-triangle'" class="me-2" />
    {{ $t("setPriceTerms.warning.depreciation") }}
  </div>

  <div
    v-if="durationMonths >= 10 && durationMonths <= 12"
    class="alert alert-danger d-flex align-items-center"
    :class="spacingClass"
    data-testid="no-sale-warning"
  >
    <font-awesome-icon :icon="'fas fa-exclamation-circle'" class="me-2" />
    {{ $t("setPriceTerms.warning.noSaleAt12") }}
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    durationMonths: number;
    spacingClass?: string;
  }>(),
  {
    spacingClass: "mb-3",
  }
);
</script>
